import {postCancelMentoryUser, postRequestMentoryUser, getItems} from "../../../api/repositories/mentories";

export default {

  async postRequestMentory({ commit }, { _body }) {
    try {

      commit("SET_LOADING", true);
      const response = await postRequestMentoryUser(_body);

      commit("SET_MENTORY_USER", response.mentoryUser);

      commit("SET_LOADING", false);
      return response
      
    } catch (error) {
      commit("SET_LOADING", false);
    }
  },


  async getMentoryUser({ commit }, { _id }) {
    try {

      commit("SET_LOADING_MENTORY_USER", true);
      const data = await getItems(_id);
      
      commit("SET_MENTORY_USER", data);
      commit("SET_LOADING_MENTORY_USER", false);
      
    } catch (error) {
      commit("SET_LOADING_MENTORY_USER", false);
    }
  },

  changeMentoryUser({ commit }, {data}){

    commit("SET_MENTORY_USER", data);

  },

  async cancelMentoryUser({ commit }, { _body }) {
    try {

      commit("SET_LOADING_MENTORY_USER", true);
      const response = await postCancelMentoryUser(_body);
      commit("SET_MENTORY_USER", response.metoryUser);
      commit("SET_LOADING_MENTORY_USER", false);
      return response
      
    } catch (error) {
      commit("SET_LOADING_MENTORY_USER", false);
    }
  },
};
